import styled from '@emotion/styled';
import { CardBasic } from 'components/Card/Card';
import { PageSizing } from 'components/Layout/PageContentWidth';

export const BigCard = styled(CardBasic)`
  padding-top: 15px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  > div:last-of-type {
    flex: 1;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 6px;
  h3 {
    margin-top: -1px; // Design nudge
    line-height: 1; // Sidestep bootstrap
  }
`;

export const BigTitle = styled.div`
  align-items: flex-start;
  h3 {
    margin-top: 4px;
  }
  button {
    margin: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const RightHeader = styled.div`
  margin-right: 20px;
  margin-top: -4px;
  display: flex;
  justify-content: start;
`;

export const StyledPageSizing = styled(PageSizing)`
  overflow: hidden;
`;
